import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import * as LibReducer from 'dealer-reducers'
import { layoutReducer } from '../redux/layoutReducer'

const tableToolsPersistConfig = {
  key: 'tableTools',
  storage,
  whitelist: ['filters']
}

const layoutPersistConfig = {
  key: 'layout',
  storage,
  whitelist: ['columns', 'paginationType', 'isPurchaseMenuOpen', 'isSettingsMenuOpen', 'isSellingVehiclesMenuOpen']
}

export const persistedTableToolsReducer = persistReducer(tableToolsPersistConfig, LibReducer.tableToolsReducer)
export const persistedLayoutReducer = persistReducer(layoutPersistConfig, layoutReducer)
